import {Dropdown, MenuItem} from 'react-bootstrap'
import Toggle from './Toggle'
import MonthSelectBox from './MonthSelectBox'
import RangeBox from './RangeBox'
import DateBox from './DateBox'
import ApplyBox from './ApplyBox'
import moment from 'moment'
import styles from './DropdownCalendar.css'
import * as apiUpdateFilteredDate from 'api/update-filtered-date'
import {isFullSiteMode} from 'utils/fullSite'

class DropdownCalendar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      startDate: null,
      endDate: null,
      month: null,
      year: null
    }
  }

  componentWillReceiveProps (nextProps) {
    let {input} = nextProps
    if (input) {
      let {value} = input
      let {startDate, endDate} = this.state
      if (!startDate || !moment(value.startDate).isSame(startDate)) {
        startDate = moment(value.startDate).startOf('days')
        this.setState({
          month: startDate.month(),
          year: startDate.year()
        })
      }
      if (!endDate || !moment(value.endDate).isSame(endDate)) {
        endDate = moment(value.endDate).startOf('days')
      }
      this.setState({
        startDate: startDate,
        endDate: endDate
      })
    }
  }
  componentDidMount () {
    // Don't remove this code, this code for https://mokapos.atlassian.net/browse/FD-38#comment-34124 (first comment)
    $('div#dropdown-box-calendar ul.dropdown-menu li a[role="menuitem"]').removeAttr('href')
  }

  render () {
    return (
      <div className={styles.wrapper} id='dropdown-box-calendar'>
        <Dropdown id='dropdown-group' open={this.state.open} onToggle={this._onToggleDropdown}>
          <div className='btn-group'>
            <a className={`btn btn-default ${styles['btn-prev-day']}`} onClick={this._onClickPrevButton}>
              <i className='fa fa-angle-left' />
            </a>
            <Toggle
              bsRole='toggle'
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onClick={this._onClickToggle}
            />
          </div>
          <a
            disabled={this._disableNextButton()}
            className={`btn btn-default ${styles['btn-next-day']}`}
            onClick={this._onClickNextButton}
            type='button'>
            <i className='fa fa-angle-right' />
          </a>
          <Dropdown.Menu bsRole='menu' className={isFullSiteMode() ? styles['menu-full-site'] : ''}>
            <MenuItem bsClass='menu-item dropdown' onClick={() => { this._forceOpen = true }}>
              <div className='row'>
                <div className='col-sm-12'>
                  <div className='col-sm-8 element-non-mobi'>
                    <ApplyBox onApply={this._onClickApply} startDate={this.state.startDate} endDate={this.state.endDate} />
                    <MonthSelectBox month={this.state.month} year={this.state.year} onChange={this._onChangeMonthSelectBox} />
                    <DateBox startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      month={this.state.month}
                      year={this.state.year}
                      onChange={this._onChangeDateBox} />
                  </div>
                  <div className='col-sm-4 element-non-mobi'>
                    <RangeBox onChange={this._onClickRangeBox} />
                  </div>
                  { !isFullSiteMode()
                    ? <div className='col-sm-12 element-mobi'>
                      <RangeBox onChange={this._onClickRangeBox} />
                    </div>
                    : <div>
                      <div className='col-sm-8 element-mobi'>
                        <ApplyBox onApply={this._onClickApply} startDate={this.state.startDate} endDate={this.state.endDate} />
                        <MonthSelectBox month={this.state.month} year={this.state.year} onChange={this._onChangeMonthSelectBox} />
                        <DateBox startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          month={this.state.month}
                          year={this.state.year}
                          onChange={this._onChangeDateBox} />
                      </div>
                      <div className='col-sm-4 element-mobi'>
                        <RangeBox onChange={this._onClickRangeBox} />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>)
  }

  _onClickToggle = () => {
    const {open} = this.state
    this.setState({open: !open})
  };

  _onToggleDropdown = (newValue) => {
    if (this._forceOpen) {
      this.setState({ open: true })
      this._forceOpen = false
    } else {
      this.setState({ open: newValue })
    }
  };

  _onClickPrevButton = (e) => {
    let diff = Math.abs(this.state.startDate.diff(this.state.endDate, 'days'))
    let newStartDate
    let newEndDate
    // if same, it means the startdate and enddate is same, and adjust it to -1
    if (diff === 0) {
      newStartDate = moment(this.state.startDate).add(-1, 'days')
      newEndDate = moment(this.state.endDate).add(-1, 'days')
    } else {
      newEndDate = moment(this.state.startDate)
      newStartDate = moment(this.state.startDate).add(-diff, 'days')
    }
    newStartDate.startOf('days')
    newEndDate.startOf('days')
    this._reduxFormOnChange({startDate: newStartDate, endDate: newEndDate})
  };

  _onClickNextButton = (e) => {
    if (this._disableNextButton()) {
      return false
    }
    // get difference
    let diff = Math.abs(this.state.startDate.diff(this.state.endDate, 'days'))
    let newStartDate
    let newEndDate
    if (diff === 0) {
      newStartDate = moment(this.state.startDate).add(1, 'days')
      newEndDate = moment(this.state.endDate).add(1, 'days')
    } else {
      newStartDate = moment(this.state.endDate)
      newEndDate = moment(this.state.endDate).add(diff, 'days')
    }
    // avoid out of range value
    if (newEndDate.isAfter(moment(), 'day')) {
      newEndDate = moment()
    }
    if (newStartDate.isAfter(newEndDate, 'day')) {
      newStartDate = moment(newEndDate).add(-1, 'days')
    }
    newStartDate.startOf('days')
    newEndDate.startOf('days')
    this._reduxFormOnChange({startDate: newStartDate, endDate: newEndDate})
  };

  _onClickApply = ({startDate, endDate}) => {
    this.setState({ open: false })
    this._forceOpen = false
    this._reduxFormOnChange({startDate, endDate})
  }

  _onClickRangeBox = ({startDate, endDate}) => {
    this.setState({ open: false })
    this._forceOpen = false
    this._reduxFormOnChange({startDate, endDate})
  }

  _onChangeDateBox = ({startDate, endDate}) => {
    this.setState({startDate, endDate})
  }

  _onChangeMonthSelectBox = ({year, month}) => {
    this.setState({year, month})
  }

  _disableNextButton = () => {
    return !moment(this.state.endDate).isBefore(moment(), 'days')
  }

  /**
   * Wrapper for redux form on change
   * place before and after action in this method
   * @private
   */
  _reduxFormOnChange = ({startDate, endDate}) => {
    const {input: {onChange}, updateServerOnChange, onDirtyFormCallback, isDirtyForm} = this.props
    if (updateServerOnChange) {
      // call api without worry about its result
      const apiFunction = apiUpdateFilteredDate.updateFilteredDate
      apiFunction({from: moment(startDate).format('D/M/YYYY'), to: moment(endDate).format('D/M/YYYY')})
    }
    if (isDirtyForm) {
      onDirtyFormCallback({startDate, endDate})
    } else {
      onChange({startDate, endDate})
    }
  }
}

DropdownCalendar.propTypes = {
  input: React.PropTypes.object,
  updateServerOnChange: React.PropTypes.bool
}

export default DropdownCalendar



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownCalendar/DropdownCalendar.js